exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sm-btn {\n  width: 111px; }\n\n.lg-btn {\n  width: 308px; }\n\n.btn-default.active {\n  background-color: #eff0f4;\n  border-color: #babbc7; }\n\n.btn-togglit-purple.active {\n  background-color: #343dab;\n  border-color: #343dab; }\n\n.btn-togglit-darkpurple.active {\n  background-color: #1F2580;\n  border-color: #1F2580; }\n\n.btn-togglit.active {\n  background-color: #b2c02c;\n  border-color: #b2c02c; }\n\n.btn-togglit-red.active {\n  background-color: #B52436;\n  border-color: #B52436; }\n\n.active {\n  box-shadow: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/loader-button/loader-button.component.scss
// module id = ../../../../../src/app/shared/components/loader-button/loader-button.component.scss
// module chunks = 12